/**
 * UI copy, keyed. Ukrainian is the source language; English mirrors it.
 * Keys are grouped by surface so a missing one is easy to spot.
 */
export const translations = {
  uk: {
    // --- bottom nav / layout
    'intro.title': 'Наверни борщу!',
    'intro.lead': 'Мапа найсмачніших борщів України — від людей, які їх куштували.',
    'intro.point1': 'Знаходь борщі поруч на мапі',
    'intro.point2': 'Дивись чесні оцінки за 7 критеріями',
    'intro.point3': 'Оцінюй сам і додавай свої знахідки',
    'intro.allow': 'Показати борщі поруч',
    'intro.later': 'Пізніше',
    'intro.note': 'Геолокація потрібна лише щоб показати найближчі борщі. Можна змінити будь-коли.',
    'faq.title': 'Часті питання',
    'faq.q1': 'Що таке «Наверни Борщу»?',
    'faq.a1': 'Це мапа закладів, де можна поїсти борщ. Спільнота оцінює борщі за смаковими критеріями — мʼясовитість, буряковість, густина, солоність, післясмак і подача — щоб ти знайшов найкращий борщ поруч.',
    'faq.q2': 'Як знайти борщ у своєму місті?',
    'faq.a2': 'На головній мапі обери місто (або дозволь геолокацію — застосунок сам визначить найближче). Позначки на мапі — заклади з борщем; тисни на позначку, щоб побачити деталі, оцінки та відгуки.',
    'faq.q3': 'Як оцінити борщ?',
    'faq.a3': 'Відкрий сторінку борща і натисни «Оцінити». Далі — сім екранів: шість смакових критеріїв і загальна оцінка, по одному питанню на екран. За бажанням додай фото та кілька слів. Щоб зберегти оцінку, потрібен акаунт.',
    'faq.q4': 'Як додати новий борщ або заклад?',
    'faq.a4': 'Увійди в акаунт і скористайся кнопкою додавання борща. Обери заклад на мапі (або створи новий), вкажи назву борща, ціну, вагу і додай фото — після цього борщ зʼявиться на мапі для всіх.',
    'faq.q5': 'Чому біля борща стоїть «ще без оцінок»?',
    'faq.a5': 'Цей борщ щойно додали, і його ще ніхто не оцінив. Стань першим — скуштуй і залиш оцінку!',
    'faq.q6': 'Навіщо реєструватися?',
    'faq.a6': 'Без акаунта можна дивитися мапу, борщі та відгуки. Акаунт потрібен, щоб оцінювати борщі, писати відгуки, додавати нові борщі та зберігати улюблені.',
    'faq.q7': 'Як зберегти улюблений борщ?',
    'faq.a7': 'На сторінці борща натисни іконку серця — борщ зʼявиться у розділі «Обране» твого профілю.',
    'faq.q8': 'Знайшов помилку або маєш ідею — куди писати?',
    'faq.a8': 'Найшвидше — кнопка з жучком у меню: вона надсилає звіт разом із тим, що було на екрані, тож помилку видно без переписки. А ще ми завжди раді фідбеку через сторінку контактів на navernyborshchu.com.',
    'help.title': 'Допомога',
    'help.guide': 'Гайд по додатку',
    'guide.title': 'Гайд по додатку',
    'guide.findTitle': 'Знайти борщ',
    'guide.findText': 'Мапа показує заклади з борщем. Число на позначці — середня оцінка. Фільтри звужують пошук за оцінкою, мʼясом, типом закладу і ціною, а «Список» показує те саме рядками — з відстанню, якщо дозволено геолокацію.',
    'guide.rateTitle': 'Оцінити борщ',
    'guide.rateText': 'Сім екранів, по одному питанню на кожному: шість смакових критеріїв і загальна оцінка. Далі — фото й коментар, обидва за бажанням. За кожен крок нараховується XP.',
    'guide.addTitle': 'Додати свій борщ',
    'guide.addText': 'Кнопка «+» посередині нижньої панелі. Обери заклад на мапі, вкажи назву, ціну й вагу — і борщ побачать усі.',
    'guide.replay': 'Показати вступний екран ще раз',
    'personal.title': 'Особиста інформація',
    'personal.name': 'Імʼя',
    'personal.country': 'Країна',
    'personal.save': 'Зберегти',
    'personal.saved': 'Збережено ✅',
    'password.title': 'Зміна пароля',
    'password.current': 'Поточний пароль',
    'password.new': 'Новий пароль',
    'password.confirm': 'Підтвердити пароль',
    'password.change': 'Змінити пароль',
    'nav.map': 'Мапа',
    'nav.showList': 'Показати списком',
    'nav.showMap': 'Показати на мапі',
    'nav.favourites': 'Обране',
    'nav.addBorsch': 'Додати борщ',
    'nav.reviews': 'Відгуки',
    'nav.you': 'Ви',
    'layout.socialTitle': 'Ми в соцмережах',
    'layout.socialLine1': 'Підписуйся, щоб бути у курсі',
    'layout.socialLine2': 'борщових новин',

    // --- скарга на ваду (жучок у навігації)
    'bug.trigger': 'Помилка',
    'bug.aria': 'Повідомити про помилку',
    'bug.title': 'Щось зламалось?',
    'bug.hint': 'Напишіть, що пішло не так. Сторінку, мову й браузер додамо самі — переказувати їх не треба.',
    'bug.placeholder': 'Наприклад: після фото оцінка не збереглась',
    'bug.cancel': 'Скасувати',
    'bug.send': 'Надіслати',
    'bug.thanksTitle': 'Дякуємо!',
    'bug.thanksHint': 'Звіт уже в нас — разом із тим, що відбувалось на екрані до поломки.',
    'bug.failTitle': 'Не вдалося надіслати',
    'bug.failHint': 'Схоже, браузер блокує нашу аналітику, а звіти їдуть саме нею. Напишіть нам в інстаграм — прочитаємо там.',
    'bug.failLink': 'Написати в Instagram',
    'bug.close': 'Закрити',

    // --- заклад зачинився або переїхав (рядок під адресою)
    'venue.link': 'Заклад зачинився або переїхав?',
    'venue.title': 'Що з цим закладом?',
    'venue.hint': 'Оберіть, що сталось.',
    'venue.closed': 'Зачинився',
    'venue.moved': 'Переїхав',
    'venue.notePlaceholder': 'Деталі, якщо знаєте: нова адреса, коли зачинився…',
    'venue.cancel': 'Скасувати',
    'venue.send': 'Надіслати',
    'venue.thanksTitle': 'Дякуємо!',
    'venue.thanksHint': 'Сигнал у нас. Ми звіряємо такі скарги, перш ніж щось міняти на мапі — одна людина може й помилитись.',
    'venue.failTitle': 'Не вдалося надіслати',
    'venue.failHint': 'Схоже, браузер блокує нашу аналітику, а сигнал їде саме нею. Напишіть нам в інстаграм — прочитаємо там.',
    'venue.failLink': 'Написати в Instagram',
    'venue.close': 'Закрити',

    // --- map
    'map.searchPlaceholder': 'Введіть назву закладу',
    // --- search autocomplete (topbar)
    'search.nearby': 'Заклади поруч',
    'search.topCity': 'Найкращі у місті ({city})',
    'search.noMatches': 'Нічого не знайдено',
    'search.venue': 'заклад',
    'search.dish': 'борщ',
    'map.filters': 'Фільтри',
    'map.byRating': 'За рейтингом',
    'sort.label': 'Сортування',
    'sort.best': 'Найкращі',
    'sort.near': 'Найближчі',
    'sort.cheapest': 'Найдешевші',
    'sort.expensive': 'Найдорожчі',
    'map.register': 'Зареєструватись',
    'map.login': 'Увійти',
    'map.clearSearch': 'Очистити пошук',
    'map.search': 'Пошук',
    'map.list': 'Список',
    'map.loadingMap': 'Завантаження карти...',
    'map.loadingPlaces': 'Завантаження закладів...',
    'map.noResults': 'За вашим запитом жодного закладу не знайдено',
    'map.closeMessage': 'Закрити повідомлення',
    'map.borschesOnMap': '{count} борщів на мапі',
    'map.loadingShort': 'завантаження…',
    'map.nearby': 'Поруч',

    // --- filter sheet
    'filter.score': 'Оцінка',
    'filter.taste': 'Смак за критеріями',
    'filter.meat': "М'ясо",
    'filter.venue': 'Заклад',
    'filter.price': 'Ціна',
    'filter.any': 'будь-яка',
    'filter.reset': 'Скинути',
    'filter.show': 'Показати {count} борщів',
    'filter.show_one': 'Показати {count} борщ',
    'filter.show_few': 'Показати {count} борщі',
    'filter.nothingFound': 'Нічого не знайдено',
    'filter.priceNote': 'Борщі без вказаної ціни не показуються',
    'filter.meatNone': "Без м'яса",
    'filter.meatChicken': 'Курка',
    'filter.meatPork': 'Свинина',
    'filter.meatBeef': 'Телятина',
    'filter.meatOther': 'Інше',
    'filter.typeRestaurant': 'Ресторан',
    'filter.typeCafe': 'Кафе',
    'filter.typeBistro': 'Бістро',
    'filter.typePub': 'Паб',

    // --- favourites / my reviews
    'fav.title': 'Обране',
    'fav.empty': 'Поки немає обраних борщів',
    'fav.emptyHint': 'Натисніть ♥ на борщі, що сподобались',
    'fav.myScore': 'Моя оцінка',
    'rev.title': 'Мої відгуки',
    'rev.empty': 'Поки немає відгуків',
    'rev.emptyHint': 'Оцініть борщ, і вони зʼявляться тут',

    // --- add-borsch flow
    'add.title': 'Додати борщ',
    'add.hint': 'Торкніться мапи там, де його подають',
    'add.cancel': 'Скасувати',
    'add.cityPlaceholder': 'В якому місті додаш борщчику?',
    'add.venuePlaceholder': 'Назва закладу або місто',
    'add.hintVenue': 'Знайди заклад пошуком або торкнись його на мапі',
    'add.otherNearby': 'Не той заклад? Поруч також:',
    'add.venueName': 'Назва закладу',

    // --- list
    'list.searchPlaceholder': 'Пошук борщу або закладу',
    // The borsch page printed a hardcoded English "Reviews" to Ukrainian
    // readers — on the screen people land on from the map.
    'card.reviewCount': '{count} відгуків',
    'card.reviewCount_one': '{count} відгук',
    'card.reviewCount_few': '{count} відгуки',
    'list.count': '{count} борщів',
    'list.count_one': '{count} борщ',
    'list.count_few': '{count} борщі',
    'list.empty': 'Тут поки порожньо',
    'list.emptySearch': 'За вашим запитом нічого не знайдено',
    'list.resetSearch': 'Скинути пошук',
    'list.ratingsShort': '{count} оц.',
    'list.clear': 'Очистити',

    // --- borsch card / popup
    'card.rating': 'Оцінка',
    'card.noRatings': 'Ще без оцінок',
    'card.about': 'Про борщик',
    'card.rate': 'Оцінити',
    'card.unknownPlace': 'Невідоме місце',
    'card.share': 'Поділитись',
    'card.like': 'Додати в улюблені',
    'card.unlike': 'Прибрати з улюблених',
    'card.route': 'Маршрут',
    'card.routeLong': 'Прокласти маршрут',
    'card.close': 'Закрити',
    'card.prevBorsch': 'Попередній борщ',
    'card.nextBorsch': 'Наступний борщ',
    'card.prevPhoto': 'Попереднє фото',
    'card.nextPhoto': 'Наступне фото',
    'card.prevBorschList': 'Прокрутити назад',
    'card.nextBorschList': 'Прокрутити вперед',
    'card.emptyPlace': 'Тут ще немає оцінених борщів.',
    'card.shareTitle': 'Перегляньте цей борщ',
    'card.shareText': 'Дивись ось цю сторінку борща:',
    'card.shareCopied': 'Посилання скопійоване в буфер. Поділитись можна вручну.',
    'photo.loading': 'Борщ вариться — фото завантажується…',

    // --- profile: added borsches
    'added.loading': 'Завантаження борщів…',
    'added.empty': 'Поки що немає доданих борщів',

    // --- auth
    'auth.title': 'Вхід або реєстрація',
    'auth.subtitle': 'Один крок — і ви зможете оцінювати борщі та зберігати улюблені.',
    'auth.consentPre': 'Я погоджуюся з',
    'auth.terms': 'Умовами користування',
    'auth.and': 'та',
    'auth.privacy': 'Політикою конфіденційності',
    'auth.google': 'Продовжити з Google',
    'auth.error': 'Не вдалося увійти через Google. Спробуйте ще раз.',
    'auth.consentHint': 'Погодьтесь з умовами користування',

    // --- profile / settings
    'profile.title': 'Мій профіль',
    'profile.tabProfile': 'Профіль',
    'profile.tabSettings': 'Налаштування',
    'profile.myReviews': 'Мої відгуки',
    'profile.personalInfo': 'Особиста інформація',
    'profile.addedBorsches': 'Додані борщі',
    'profile.password': 'Пароль',
    'profile.logout': 'Вийти з акаунту',
    'profile.about': 'Про додаток',
    'profile.help': 'Help',
    'profile.privacy': 'Політика конфіденційності',
    'profile.advertTitle': 'Наверни Борщу - і друзів запроси!',
    'profile.advertText': 'Поділись додатком зі своїми. Разом смачніше!',
    'settings.theme': 'Тема',
    'settings.themeAuto': 'Авто',
    'settings.themeLight': 'Світла',
    'settings.themeDark': 'Темна',
    'settings.language': 'Мова',

    // --- rating screen
    'rate.title': 'Оціни смак борщу',
    'rate.loading': 'Завантаження даних...',
    'rate.notFound': 'Цей борщ не знайдено',
    'rate.comment': 'Коментар:',
    'rate.commentPlaceholder': 'Додайте коментар....',
    'rate.save': 'Зберегти',
    'rate.saveRemaining': 'Оцініть ще {count}',
    'rate.progress': 'Оцінено {done} з {total}',

    // --- gamified rating flow
    'flow.step': 'Крок {n} з {total}',
    'flow.next': 'Далі',
    'flow.back': 'Назад',
    'flow.skip': 'Пропустити',
    'flow.toBorsch': 'До борщу',
    'flow.finish': 'Готово',
    'flow.firstTitle': 'Ти Першовар! 🥇',
    'flow.firstText': 'Ти перший, хто скуштував і оцінив цей борщ. Твоє імʼя тепер на його картці.',
    'flow.confirmedTitle': 'Оцінку підтверджено! ✅',
    'flow.confirmedText': 'До тебе цей борщ мав лише оцінку з каталогу засновників. Тепер її підтвердила спільнота.',
    'flow.xpTotal': 'Разом у тебе: {n} XP',
    'explore.beFirst': '🔍 Цього борщу ще ніхто не куштував. Стань Першоваром — ×3 XP!',
    'explore.confirmIt': '✅ Оцінка з каталогу засновників. Підтвердь її — ×2 XP',
    'explore.discoveredBy': '🥇 Першовар: {name} · {date}',
    'explore.discoveredAnon': '🥇 Розвідано спільнотою · {date}',
    'quest.virginCount': 'Нерозвіданих борщів: {count}',
    'quest.unverifiedCount': 'Непідтверджених оцінок: {count}',
    'quest.nextNear': 'Найближчий — {d}. Показати →',
    'quest.next': 'Показати наступний →',
    // short forms for the plaque on the map, where a sentence would not fit
    'quest.virginShort': 'Нерозвіданих: {count}',
    'quest.unverifiedShort': 'Непідтверджених: {count}',
    'quest.nextNearShort': 'найближчий {d} →',
    'quest.nextShort': 'показати →',
    'flow.praiseLow': 'Буває… дякуємо за чесність!',
    'flow.praiseMid': 'Ок, нормально',
    'flow.praiseGood': 'Смачно!',
    'flow.praiseTop': 'Вау, це любов!',
    'flow.photoTitle': 'Покажи свій борщ',
    'flow.photoHint': 'Найкращий момент — поки не взяв ложку. Можна кілька, і це необовʼязково.',
    'flow.photoPick': 'Додати фото',
    'flow.photoAddMore': 'Додати ще',
    'flow.photoRemove': 'Прибрати фото',
    'flow.photoCount': '{n} з {max} фото',
    'flow.photoRetake': 'Інше фото',
    'flow.photoFailed': 'Оцінку збережено, але фото не завантажилось: {n} з {total}.',
    'flow.photoRetry': 'Спробувати ще раз',
    'flow.photoRetryOk': 'Фото завантажено ✅',
    'flow.commentTitle': 'Кілька слів?',
    'flow.commentHint': 'Що запамʼяталось? Теж необовʼязково.',

    // --- quest flow: the questions, in the words a person would use
    'flow.q.meat': 'Скільки в ньому було мʼяса?',
    'flow.q.beetroot': 'Який був колір?',
    'flow.q.density': 'Наскільки густий?',
    'flow.q.salt': 'Як там із сіллю?',
    'flow.q.aftertaste': 'Який післясмак?',
    'flow.q.serving': 'Як подали?',
    'flow.q.overall': 'То як тобі борщ загалом?',

    'ans.meat1': 'Жодного шматочка',
    'ans.meat2': 'Пару волокон',
    'ans.meat3': 'Нормально',
    'ans.meat4': 'Щедро',
    'ans.meat5': 'У кожній ложці',
    'ans.beetroot1': 'Ледь рожевий',
    'ans.beetroot2': 'Світлуватий',
    'ans.beetroot3': 'Рівний бордовий',
    'ans.beetroot4': 'Насичений',
    'ans.beetroot5': 'Глибокий бордо',
    'ans.density1': 'Як юшка',
    'ans.density2': 'Рідкуватий',
    'ans.density3': 'Збалансований',
    'ans.density4': 'Густий',
    'ans.density5': 'Ложка стоїть',
    'ans.salt1': 'Прісний',
    'ans.salt2': 'Малувато солі',
    'ans.salt3': 'Саме як треба',
    'ans.salt4': 'Солонувато',
    'ans.salt5': 'Пересолений',
    'ans.aftertaste1': 'Несмачно',
    'ans.aftertaste2': 'Нічого особливого',
    'ans.aftertaste3': 'Приємний',
    'ans.aftertaste4': 'Смачний',
    'ans.aftertaste5': 'Вау!',
    'ans.serving1': 'Неохайно',
    'ans.serving2': 'Без старань',
    'ans.serving3': 'Нормально',
    'ans.serving4': 'Гарно',
    'ans.serving5': 'Ресторанний стиль',
    'ans.overall1': 'Більше не візьму',
    'ans.overall2': 'Так собі',
    'ans.overall3': 'Нормально',
    'ans.overall4': 'Смачно',
    'ans.overall5': 'Повернусь по добавку',

    // --- quest flow: adding a borsch, the facts asked AFTER the tasting
    'flow.qMeatType': 'Яке мʼясо було в борщі?',
    'ans.meatNo': 'Без мʼяса',
    'ans.meatChicken': 'Курка',
    'ans.meatPork': 'Свинина',
    'ans.meatBeef': 'Яловичина',
    'ans.meatOther': 'Інше',
    'flow.qName': 'Як він називався в меню?',
    'flow.qNameHint': 'За назвою його знайдуть інші',
    'flow.qNamePlaceholder': 'Напр. Борщ український',
    'chip.borsch': 'Борщ',
    'chip.borschRed': 'Червоний борщ',
    'chip.borschGreen': 'Зелений борщ',
    'chip.borschPampushky': 'Борщ з пампушками',
    'flow.qPrice': 'Скільки він коштував?',
    'flow.qPriceHint': 'Ціна з меню, за одну порцію',
    'flow.qWeight': 'Яка була порція?',
    'flow.qWeightHint': 'Приблизно — грамів у порції',
    'flow.unitUah': '₴',
    'flow.unitEur': '€',
    'flow.unitGram': 'г',
    'flow.signinTitle': 'Збережемо твій борщ?',
    'flow.signinHint': 'Оцінка вже зібрана. Один тап — і борщ зʼявиться на мапі, а Першовар буде твоїм.',
    'flow.signedIn': 'Готово, ти в акаунті',
    'flow.signinRequired': 'Потрібен вхід, щоб зберегти борщ. Увійди й натисни «Спробувати ще раз».',
    'flow.addedTitle': 'Борщ на мапі! 🎉',
    'flow.addedText': 'Ти Першовар цього борщу — твоя оцінка стала його першою.',
    'flow.stagePlace': 'Знаходимо заклад…',
    'flow.stageBorsch': 'Додаємо борщ…',
    'flow.stageReview': 'Зберігаємо оцінку…',
    'flow.stagePhoto': 'Завантажуємо фото…',
    'flow.quitConfirm': 'Вийти? Твої відповіді не збережуться.',
    'flow.noPlace': 'Спершу вибери заклад на мапі.',
    'flow.pickPlace': 'Вибрати заклад',
    'rate.overall': 'Загальна оцінка',
    'rate.overallLeft': 'більше не візьму',
    'rate.overallRight': 'повернусь по добавку',
    'rate.meat': "М'ясовитість",
    'rate.meatLeft': 'жодного шматочка',
    'rate.meatRight': 'у кожній ложці',
    'rate.beetroot': 'Буряковість',
    'rate.beetrootLeft': 'ледь рожевий',
    'rate.beetrootRight': 'насичено-бордовий',
    'rate.density': 'Густина',
    'rate.densityLeft': 'рідкий',
    'rate.densityRight': 'ложка стоїть',
    'rate.salt': 'Солоність',
    'rate.saltLeft': 'прісний',
    'rate.saltRight': 'пересолений',
    'rate.aftertaste': 'Післясмак',
    'rate.aftertasteLeft': 'несмачно',
    'rate.aftertasteRight': 'вау!',
    'rate.serving': 'Подача',
    'rate.servingLeft': 'неохайно',
    'rate.servingRight': 'ресторанний стиль',
    'rate.noRatingsYet': 'ще без оцінок',
    'rate.saving': 'Зберігаємо оцінку…',
    'rate.savingHint': 'Ще мить',
    'rate.thanks': 'Дякуємо за відгук!',
    'rate.thanksText': 'Ми його вже помішуємо - подамо після модерації',
    'rate.backHome': 'Повернутись на головну',
    'rate.failed': 'Не вдалося зберегти',
    'rate.retry': 'Спробувати ще раз',
    'rate.failedHint': 'Спробуйте ще раз.',
    'rate.saveError': 'Не вдалося зберегти оцінку. Спробуйте ще раз.',

    // --- city sheet
    'city.title': 'Населений пункт',
    'city.placeholder': 'Назва населеного пункту',
    'city.popular': 'Популярні',
    'city.all': 'Всі',

    // --- register/logout modals
    'modal.noProfileTitle': 'Без профілю? Це як борщ без сметани!',
    'modal.noProfileText': 'Наче все ок, але чогось не вистачає. Створи профіль - і буде повний смак',
    'modal.createProfile': 'Створити профіль',
    'modal.haveProfile': 'Вже маєш профіль?',
    'modal.signIn': 'Увійти',
    'modal.notNow': 'Не зараз',

    // --- geolocation
    'geo.blockedTitle': 'Доступ до геолокації заблоковано.',
    'geo.failedTimeout': 'Не вдалося визначити місцезнаходження (час вийшов).',
    'geo.unavailable': 'Геолокація зараз недоступна.',
    'geo.hintBrowser': 'Перевірте налаштування доступу до геолокації у браузері.',
    'geo.hintDenied': 'Дозвольте геодані для цього сайту в налаштуваннях браузера (іконка замка біля адреси).',
    'geo.hintTimeout': 'Перевірте, чи увімкнена геолокація на пристрої, і спробуйте ще раз.',
    'geo.hintUnavailable': 'Пристрій не зміг визначити позицію. Перевірте, чи увімкнені геодані.',
    'add.pickPlace': 'Вибрати заклад',
    'add.openNow': 'Відчинено',
    'add.closedNow': 'Зачинено',
    'add.willClose': 'Закриється',
    'add.willOpen': 'Відкриється',
    'geo.failedTitle': 'Не вдалося визначити місцезнаходження.',
    'geo.pickCity': 'Вибрати місто вручну',
  },

  en: {
    'intro.title': 'Get your borshch!',
    'intro.lead': 'A map of Ukraine\u2019s tastiest borshch — from the people who ate it.',
    'intro.point1': 'Find borshch near you on the map',
    'intro.point2': 'See honest scores across 7 criteria',
    'intro.point3': 'Rate your own and add new finds',
    'intro.allow': 'Show borshch near me',
    'intro.later': 'Later',
    'intro.note': 'Location is only used to show the closest borshch. You can change this any time.',
    'faq.title': 'FAQ',
    'faq.q1': 'What is “Naverny Borshchu”?',
    'faq.a1': 'A map of places serving borshch. The community rates each one on taste criteria — meatiness, beetroot, density, saltiness, aftertaste and presentation — so you can find the best borshch near you.',
    'faq.q2': 'How do I find borshch in my city?',
    'faq.a2': 'Pick a city on the map (or allow location and the app finds the nearest one). Each pin is a venue serving borshch; tap it for details, scores and reviews.',
    'faq.q3': 'How do I rate a borshch?',
    'faq.a3': 'Open a borshch and press “Rate”. Then it is seven screens: six taste criteria and an overall score, one question per screen. Add a photo and a few words if you like. Saving a rating needs an account.',
    'faq.q4': 'How do I add a new borshch or venue?',
    'faq.a4': 'Sign in and use the add button. Pick a venue on the map (or create one), enter the name, price and weight, add a photo — and your borshch appears on the map for everyone.',
    'faq.q5': 'Why does a borshch say “not rated yet”?',
    'faq.a5': 'It was just added and nobody has rated it. Be the first — taste it and leave a score!',
    'faq.q6': 'Why should I register?',
    'faq.a6': 'Without an account you can browse the map, the bowls of borshch and the reviews. An account lets you rate, review, add new bowls of borshch and save favourites.',
    'faq.q7': 'How do I save a favourite?',
    'faq.a7': 'Press the heart on a borshch page — it appears under “Favourites” in your profile.',
    'faq.q8': 'Found a bug or have an idea — where do I write?',
    'faq.a8': 'Fastest is the bug button in the menu: it sends the report together with what was on your screen, so we see the problem without a back-and-forth. We also welcome feedback through the contact page at navernyborshchu.com.',
    'help.title': 'Help',
    'help.guide': 'App guide',
    'guide.title': 'App guide',
    'guide.findTitle': 'Find borshch',
    'guide.findText': 'The map shows venues serving borshch. The number on a pin is the average score. Filters narrow by score, meat, venue type and price, and “List” shows the same results as rows — with distance if you allow location.',
    'guide.rateTitle': 'Rate a borshch',
    'guide.rateText': 'Seven screens, one question each: six taste criteria and an overall score. Then a photo and a comment, both optional. Every step earns XP.',
    'guide.addTitle': 'Add your own',
    'guide.addText': 'The “+” button in the middle of the bottom bar. Pick a venue on the map, enter the name, price and weight — and everyone sees your borshch.',
    'guide.replay': 'Show the intro screen again',
    'personal.title': 'Personal information',
    'personal.name': 'Name',
    'personal.country': 'Country',
    'personal.save': 'Save',
    'personal.saved': 'Saved ✅',
    'password.title': 'Change password',
    'password.current': 'Current password',
    'password.new': 'New password',
    'password.confirm': 'Confirm password',
    'password.change': 'Change password',
    'nav.map': 'Map',
    'nav.showList': 'Show as a list',
    'nav.showMap': 'Show on the map',
    'nav.favourites': 'Saved',
    'nav.addBorsch': 'Add borshch',
    'nav.reviews': 'Reviews',
    'nav.you': 'You',
    'layout.socialTitle': 'Follow us',
    'layout.socialLine1': 'Subscribe to keep up with',
    'layout.socialLine2': 'the borshch news',

    // --- bug report (the bug icon in the nav)
    'bug.trigger': 'Bug',
    'bug.aria': 'Report a bug',
    'bug.title': 'Something broken?',
    'bug.hint': 'Tell us what went wrong. The page, language and browser come along automatically — no need to describe them.',
    'bug.placeholder': 'For example: my rating was lost after the photo step',
    'bug.cancel': 'Cancel',
    'bug.send': 'Send',
    'bug.thanksTitle': 'Thank you!',
    'bug.thanksHint': 'The report is with us — together with what happened on screen before it broke.',
    'bug.failTitle': 'Could not send',
    'bug.failHint': 'Your browser seems to be blocking our analytics, which is what carries the report. Please write to us on Instagram instead.',
    'bug.failLink': 'Write on Instagram',
    'bug.close': 'Close',

    // --- venue closed or moved (the line under the address)
    'venue.link': 'Closed down or moved?',
    'venue.title': "What's up with this venue?",
    'venue.hint': 'Pick what happened.',
    'venue.closed': 'Closed down',
    'venue.moved': 'Moved',
    'venue.notePlaceholder': 'Details, if you know them: the new address, when it closed…',
    'venue.cancel': 'Cancel',
    'venue.send': 'Send',
    'venue.thanksTitle': 'Thank you!',
    'venue.thanksHint': 'We have it. We cross-check reports like this before changing the map — one person can be mistaken.',
    'venue.failTitle': 'Could not send',
    'venue.failHint': 'Your browser seems to be blocking our analytics, which is what carries the report. Please write to us on Instagram instead.',
    'venue.failLink': 'Write on Instagram',
    'venue.close': 'Close',

    'map.searchPlaceholder': 'Search for a venue',
    'search.nearby': 'Places nearby',
    'search.topCity': 'Top rated in {city}',
    'search.noMatches': 'Nothing found',
    'search.venue': 'venue',
    'search.dish': 'borshch',
    'map.filters': 'Filters',
    'map.byRating': 'By rating',
    'sort.label': 'Sort by',
    'sort.best': 'Best',
    'sort.near': 'Nearest',
    'sort.cheapest': 'Cheapest',
    'sort.expensive': 'Most expensive',
    'map.register': 'Sign up',
    'map.login': 'Sign in',
    'map.clearSearch': 'Clear search',
    'map.search': 'Search',
    'map.list': 'List',
    'map.loadingMap': 'Loading the map…',
    'map.loadingPlaces': 'Loading venues…',
    'map.noResults': 'No venues match your search',
    'map.closeMessage': 'Close message',
    'map.borschesOnMap': '{count} bowls of borshch on the map',
    'map.borschesOnMap_one': '{count} borshch on the map',
    'map.loadingShort': 'loading…',
    'map.nearby': 'Nearby',

    'filter.score': 'Score',
    'filter.taste': 'Taste criteria',
    'filter.meat': 'Meat',
    'filter.venue': 'Venue',
    'filter.price': 'Price',
    'filter.any': 'any',
    'filter.reset': 'Reset',
    'filter.show': 'Show {count} bowls of borshch',
    'filter.show_one': 'Show {count} borshch',
    'filter.nothingFound': 'Nothing found',
    'filter.priceNote': 'Bowls of borshch with no price are hidden',
    'filter.meatNone': 'No meat',
    'filter.meatChicken': 'Chicken',
    'filter.meatPork': 'Pork',
    'filter.meatBeef': 'Beef',
    'filter.meatOther': 'Other',
    'filter.typeRestaurant': 'Restaurant',
    'filter.typeCafe': 'Cafe',
    'filter.typeBistro': 'Bistro',
    'filter.typePub': 'Pub',

    'fav.title': 'Saved',
    'fav.empty': 'No saved bowls of borshch yet',
    'fav.emptyHint': 'Tap ♥ on a borshch you liked',
    'fav.myScore': 'My score',
    'rev.title': 'My reviews',
    'rev.empty': 'No reviews yet',
    'rev.emptyHint': 'Rate a borshch and it will show up here',

    'add.title': 'Add a borshch',
    'add.hint': 'Tap the map where it is served',
    'add.cancel': 'Cancel',
    'add.cityPlaceholder': 'Which city are you adding a borshch in?',
    'add.venuePlaceholder': 'Venue name or city',
    'add.hintVenue': 'Search for the venue or tap it on the map',
    'add.otherNearby': 'Not the right one? Also nearby:',
    'add.venueName': 'Venue name',

    'list.searchPlaceholder': 'Search a borshch or venue',
    'card.reviewCount': '{count} reviews',
    'card.reviewCount_one': '{count} review',
    'list.count': '{count} bowls of borshch',
    'list.count_one': '{count} borshch',
    'list.empty': 'Nothing here yet',
    'list.emptySearch': 'Nothing matches your search',
    'list.resetSearch': 'Reset search',
    'list.ratingsShort': '{count} ratings',
    'list.ratingsShort_one': '{count} rating',
    'list.clear': 'Clear',

    'card.rating': 'Rating',
    'card.noRatings': 'No ratings yet',
    'card.about': 'About this borshch',
    'card.rate': 'Rate',
    'card.unknownPlace': 'Unknown place',
    'card.share': 'Share',
    'card.like': 'Add to favourites',
    'card.unlike': 'Remove from favourites',
    'card.route': 'Route',
    'card.routeLong': 'Get directions',
    'card.close': 'Close',
    'card.prevBorsch': 'Previous borshch',
    'card.nextBorsch': 'Next borshch',
    'card.prevPhoto': 'Previous photo',
    'card.nextPhoto': 'Next photo',
    'card.prevBorschList': 'Scroll back',
    'card.nextBorschList': 'Scroll forward',
    'card.emptyPlace': 'No rated bowls of borshch here yet.',
    'card.shareTitle': 'Check out this borshch',
    'card.shareText': 'Have a look at this borshch page:',
    'card.shareCopied': 'Link copied to the clipboard — you can share it manually.',
    'photo.loading': 'The borshch is simmering — photo is loading…',

    // --- profile: added borsches
    'added.loading': 'Loading bowls of borshch…',
    'added.empty': 'No added bowls of borshch yet',

    'auth.title': 'Sign in or sign up',
    'auth.subtitle': 'One step — and you can rate bowls of borshch and save your favourites.',
    'auth.consentPre': 'I agree to the',
    'auth.terms': 'Terms of Use',
    'auth.and': 'and',
    'auth.privacy': 'Privacy Policy',
    'auth.google': 'Continue with Google',
    'auth.error': 'Could not sign in with Google. Please try again.',
    'auth.consentHint': 'Please accept the terms of use',

    'profile.title': 'My profile',
    'profile.tabProfile': 'Profile',
    'profile.tabSettings': 'Settings',
    'profile.myReviews': 'My reviews',
    'profile.personalInfo': 'Personal information',
    'profile.addedBorsches': 'Added bowls of borshch',
    'profile.password': 'Password',
    'profile.logout': 'Log out',
    'profile.about': 'About the app',
    'profile.help': 'Help',
    'profile.privacy': 'Privacy Policy',
    'profile.advertTitle': 'Naverny Borshchu — bring your friends!',
    'profile.advertText': 'Share the app with your people. Tastier together!',
    'settings.theme': 'Theme',
    'settings.themeAuto': 'Auto',
    'settings.themeLight': 'Light',
    'settings.themeDark': 'Dark',
    'settings.language': 'Language',

    'rate.title': 'Rate the taste',
    'rate.loading': 'Loading…',
    'rate.notFound': 'This borshch was not found',
    'rate.comment': 'Comment:',
    'rate.commentPlaceholder': 'Add a comment…',
    'rate.save': 'Save',
    'rate.saveRemaining': 'Rate {count} more',
    'rate.progress': 'Rated {done} of {total}',

    'flow.step': 'Step {n} of {total}',
    'flow.next': 'Next',
    'flow.back': 'Back',
    'flow.skip': 'Skip',
    'flow.toBorsch': 'Back to the borshch',
    'flow.finish': 'Done',
    'flow.firstTitle': 'You are the First Taster! 🥇',
    'flow.firstText': 'You are the first to taste and rate this borshch. Your name is now on its card.',
    'flow.confirmedTitle': 'Score confirmed! ✅',
    'flow.confirmedText': 'Until now this borshch only carried a score from the founders’ catalogue. The community has confirmed it.',
    'flow.xpTotal': 'Your total: {n} XP',
    'explore.beFirst': '🔍 Nobody has tasted this borshch yet. Be the First Taster — ×3 XP!',
    'explore.confirmIt': '✅ Score from the founders’ catalogue. Confirm it — ×2 XP',
    'explore.discoveredBy': '🥇 First Taster: {name} · {date}',
    'explore.discoveredAnon': '🥇 Scouted by the community · {date}',
    'quest.virginCount': 'Unscouted bowls of borshch: {count}',
    'quest.unverifiedCount': 'Unconfirmed scores: {count}',
    'quest.nextNear': 'Nearest is {d} away. Show me →',
    'quest.next': 'Show the next one →',
    // short forms for the plaque on the map, where a sentence would not fit
    'quest.virginShort': 'Unscouted: {count}',
    'quest.unverifiedShort': 'Unconfirmed: {count}',
    'quest.nextNearShort': 'nearest {d} →',
    'quest.nextShort': 'show me →',
    'flow.praiseLow': 'It happens — thanks for being honest!',
    'flow.praiseMid': 'Fair enough',
    'flow.praiseGood': 'Tasty!',
    'flow.praiseTop': 'Wow, that is love!',
    'flow.photoTitle': 'Show your borshch',
    'flow.photoHint': 'Best taken before the first spoonful. As many as you like, and optional.',
    'flow.photoPick': 'Add a photo',
    'flow.photoAddMore': 'Add another',
    'flow.photoRemove': 'Remove photo',
    'flow.photoCount': '{n} of {max} photos',
    'flow.photoRetake': 'Different photo',
    'flow.photoFailed': 'Your rating is saved, but {n} of {total} photos did not upload.',
    'flow.photoRetry': 'Try again',
    'flow.photoRetryOk': 'Photos uploaded ✅',
    'flow.commentTitle': 'A few words?',
    'flow.commentHint': 'What stood out? Also optional.',

    // --- quest flow: the questions, in the words a person would use
    'flow.q.meat': 'How much meat was in it?',
    'flow.q.beetroot': 'What colour was it?',
    'flow.q.density': 'How thick was it?',
    'flow.q.salt': 'How was the salt?',
    'flow.q.aftertaste': 'How was the aftertaste?',
    'flow.q.serving': 'How was it served?',
    'flow.q.overall': 'So how was the borshch overall?',

    'ans.meat1': 'Not a single piece',
    'ans.meat2': 'A couple of strands',
    'ans.meat3': 'Enough',
    'ans.meat4': 'Generous',
    'ans.meat5': 'In every spoonful',
    'ans.beetroot1': 'Barely pink',
    'ans.beetroot2': 'A bit pale',
    'ans.beetroot3': 'Proper burgundy',
    'ans.beetroot4': 'Rich',
    'ans.beetroot5': 'Deep burgundy',
    'ans.density1': 'Like broth',
    'ans.density2': 'On the thin side',
    'ans.density3': 'Balanced',
    'ans.density4': 'Thick',
    'ans.density5': 'The spoon stands up',
    'ans.salt1': 'Bland',
    'ans.salt2': 'A little flat',
    'ans.salt3': 'Exactly right',
    'ans.salt4': 'A touch salty',
    'ans.salt5': 'Over-salted',
    'ans.aftertaste1': 'Not tasty',
    'ans.aftertaste2': 'Nothing special',
    'ans.aftertaste3': 'Pleasant',
    'ans.aftertaste4': 'Tasty',
    'ans.aftertaste5': 'Wow!',
    'ans.serving1': 'Sloppy',
    'ans.serving2': 'No effort',
    'ans.serving3': 'Fine',
    'ans.serving4': 'Nice',
    'ans.serving5': 'Restaurant style',
    'ans.overall1': 'Never again',
    'ans.overall2': 'Meh',
    'ans.overall3': 'Fine',
    'ans.overall4': 'Tasty',
    'ans.overall5': "I'd come back for seconds",

    // --- quest flow: adding a borsch, the facts asked AFTER the tasting
    'flow.qMeatType': 'What meat was in it?',
    'ans.meatNo': 'No meat',
    'ans.meatChicken': 'Chicken',
    'ans.meatPork': 'Pork',
    'ans.meatBeef': 'Beef',
    'ans.meatOther': 'Other',
    'flow.qName': 'What was it called on the menu?',
    'flow.qNameHint': 'That is how others will find it',
    'flow.qNamePlaceholder': 'e.g. Ukrainian borshch',
    'chip.borsch': 'Borshch',
    'chip.borschRed': 'Red borshch',
    'chip.borschGreen': 'Green borshch',
    'chip.borschPampushky': 'Borshch with pampushky',
    'flow.qPrice': 'What did it cost?',
    'flow.qPriceHint': 'Menu price for one bowl',
    'flow.qWeight': 'How big was the portion?',
    'flow.qWeightHint': 'Roughly — grams per bowl',
    'flow.unitUah': '₴',
    'flow.unitEur': '€',
    'flow.unitGram': 'g',
    'flow.signinTitle': 'Shall we save your borshch?',
    'flow.signinHint': 'The rating is already collected. One tap and the borshch lands on the map with your name as its First Taster.',
    'flow.signedIn': 'Done, you are signed in',
    'flow.signinRequired': 'Sign in to save the borshch, then hit “Try again”.',
    'flow.addedTitle': 'On the map! 🎉',
    'flow.addedText': 'You are this borshch’s First Taster — your score is its first.',
    'flow.stagePlace': 'Finding the venue…',
    'flow.stageBorsch': 'Adding the borshch…',
    'flow.stageReview': 'Saving your rating…',
    'flow.stagePhoto': 'Uploading the photo…',
    'flow.quitConfirm': 'Quit? Your answers will not be saved.',
    'flow.noPlace': 'Pick a venue on the map first.',
    'flow.pickPlace': 'Pick a venue',
    'rate.overall': 'Overall rating',
    'rate.overallLeft': 'never again',
    'rate.overallRight': 'coming back for seconds',
    'rate.meat': 'Meatiness',
    'rate.meatLeft': 'not a single piece',
    'rate.meatRight': 'in every spoon',
    'rate.beetroot': 'Beetroot',
    'rate.beetrootLeft': 'barely pink',
    'rate.beetrootRight': 'deep burgundy',
    'rate.density': 'Thickness',
    'rate.densityLeft': 'watery',
    'rate.densityRight': 'the spoon stands up',
    'rate.salt': 'Saltiness',
    'rate.saltLeft': 'bland',
    'rate.saltRight': 'too salty',
    'rate.aftertaste': 'Aftertaste',
    'rate.aftertasteLeft': 'unpleasant',
    'rate.aftertasteRight': 'wow!',
    'rate.serving': 'Presentation',
    'rate.servingLeft': 'sloppy',
    'rate.servingRight': 'restaurant style',
    'rate.noRatingsYet': 'no ratings yet',
    'rate.saving': 'Saving your rating…',
    'rate.savingHint': 'One moment',
    'rate.thanks': 'Thanks for your review!',
    'rate.thanksText': 'We are already stirring it — it will be served after moderation',
    'rate.backHome': 'Back to the map',
    'rate.failed': 'Could not save',
    'rate.retry': 'Try again',
    'rate.failedHint': 'Please try again.',
    'rate.saveError': 'Could not save your rating. Please try again.',

    'city.title': 'Place',
    'city.placeholder': 'Town or city name',
    'city.popular': 'Popular',
    'city.all': 'All',

    'modal.noProfileTitle': 'No profile? That is borshch without sour cream!',
    'modal.noProfileText': 'Looks fine, but something is missing. Create a profile for the full flavour',
    'modal.createProfile': 'Create a profile',
    'modal.haveProfile': 'Already have a profile?',
    'modal.signIn': 'Sign in',
    'modal.notNow': 'Not now',

    'geo.blockedTitle': 'Location access is blocked.',
    'geo.failedTimeout': 'Could not determine your location (timed out).',
    'geo.unavailable': 'Location is unavailable right now.',
    'geo.hintBrowser': 'Check the location permission in your browser settings.',
    'geo.hintDenied': 'Allow location for this site in your browser settings (the lock icon next to the address).',
    'geo.hintTimeout': 'Check that location is enabled on your device and try again.',
    'geo.hintUnavailable': 'Your device could not get a position. Check that location services are on.',
    'add.pickPlace': 'Choose this venue',
    'add.openNow': 'Open',
    'add.closedNow': 'Closed',
    'add.willClose': 'Closes',
    'add.willOpen': 'Opens',
    'geo.failedTitle': 'Could not determine your location.',
    'geo.pickCity': 'Pick a city manually',
  },
};

// City labels. The stored value stays Ukrainian (it is also the filter key);
// only the displayed label is localized/transliterated.
export const CITY_LABELS = {
  en: {
    'Київ': 'Kyiv',
    'Львів': 'Lviv',
    'Одеса': 'Odesa',
    'Харків': 'Kharkiv',
    'Дніпро': 'Dnipro',
    'Тернопіль': 'Ternopil',
    'Івано-Франківськ': 'Ivano-Frankivsk',
    'Буковель': 'Bukovel',
    'Закарпаття': 'Zakarpattia',
    'Київська обл.': 'Kyiv oblast',
    'Ріга': 'Riga',
  },
};

export const LANGUAGES = [
  { key: 'uk', label: 'Українська', short: 'UA', flag: '🇺🇦' },
  { key: 'en', label: 'English', short: 'EN', flag: '🇬🇧' },
];
